import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Index from "../views/Index.vue"

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Index,
    meta: {
      public: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      login: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: '/booking',
    name: 'Booking System',
    component: () => import('../views/Booking.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue'),
  },
  {
    path: '/reps',
    component: () => import('../views/Reps.vue'),
    children: [
      {
        path: "",
        name: "All reps",
        component: () => import('../views/AllReps.vue'),
      },
      {
        path: ":id",
        name: "View rep",
        component: () => import('../views/ViewRep.vue'),
      }
    ]
  },
  {
    path: '/me',
    name: 'My Profile',
    component: () => import('../views/Reps.vue'),
  },
  {
    path: '/tickets',
    component: () => import('../views/Tickets.vue'),
    children: [
      {
        path: "",
        name: "My tickets",
        component: () => import('../views/MyTickets.vue'),
      },
      {
        path: "all",
        name: "All tickets",
        component: () => import('../views/AllTickets.vue'),
      },
      {
        path: "search",
        name: "Search tickets",
        component: () => import('../views/SearchTickets.vue'),
      },
      {
        path: "new",
        name: "Create ticket",
        component: () => import('../views/CreateTicket.vue'),
      },
          {
            path: "/tickets/:id",
            name: "View ticket",
            beforeEnter: (to, from, next) => {
              const ticketValue = to.params.id // get the id parameter from the route
              const redirectUrl = `https://www.superiorpress.com/tac/web-app/ticket-detail-screen?ticketvalue=${ticketValue}` // create the redirect URL with the id parameter
              window.location.assign(redirectUrl) // redirect the user to the specified URL
            }
    }


    ]
  },
  {
    path: '/reports/embed',
    name: 'Reports Embed',
    component: () => import('../views/ReportsEmbed.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../views/Reports.vue'),
  },
  {
    path: '/self-upgrade',
    name: 'Self Upgrade',
    component: () => import('../views/SelfUpgrade.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '/opt-out',
    name: 'Opt Out',
    component: () => import('../views/OptOut.vue'),
    meta: {
      public: true
    }
  },
  {
    path: '/operating-requirements',
    name: 'Operating Requirements',
    component: () => import('../views/OperatingRequirements.vue'),
    meta: {
      public: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const isLoggedIn = () => {
  return localStorage.getItem(Vue.prototype.$apikeyname) ? true : false
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.public)) {
    next()
  }
  else {
    if (to.matched.some(record => record.meta.login)) {
      if (isLoggedIn()) {
        next({ name: 'Dashboard' })
      } else {
        next()
      }
    }
    else {
      if (isLoggedIn()) {
        next()
      } else {
        // next({ name: 'Login' })
        window.location.replace(`https://go.superiorpress.com/tac-login?url=${window.location.origin}`)
      }
    }
  }
})

export default router
